var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52763 2.8041C8.86366 1.46807 9.53168 0.800049 10.3618 0.800049C11.1919 0.800049 11.8599 1.46807 13.1959 2.8041C14.532 4.14013 15.2 4.80815 15.2 5.63825C15.2 6.46836 14.532 7.13637 13.1959 8.47241L9.84136 11.827L4.17306 6.15867L7.52763 2.8041Z",
    fill: "#FFE600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.32455 7.00722L8.99284 12.6755L8.47235 13.196C8.17015 13.4982 7.90214 13.7662 7.65869 14H15.2C15.5314 14 15.8 14.2687 15.8 14.6C15.8 14.9314 15.5314 15.2 15.2 15.2H5.59999C4.78737 15.1798 4.11951 14.5115 2.80403 13.196C1.468 11.86 0.799988 11.1919 0.799988 10.3618C0.799988 9.53174 1.46801 8.86372 2.80404 7.52769L3.32455 7.00722Z",
    fill: "#FFE600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/Clear.f424c1a7f6e956c73af914fc4d715642.svg";
export { ForwardRef as ReactComponent };